import React, { Fragment, useEffect, useState } from "react";
import { subDays } from 'date-fns';
import { CSSTransition } from 'react-transition-group';
import { Row, Col, Card, CardBody, CardTitle, Container } from "reactstrap";
import Common from "../../Common/Common";
import FormHeader from "../../Common/FormHeader";
import ToperReports from "./Analysis/ToperReports";
import { callType, chartsList } from "./Constants";
import Summary from "../../Common/Summary";
import requestApi from "../../services/requestApi.service";
import {faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons/faMagnifyingGlass";
import ReactApexChart from "react-apexcharts";
export default function CallLogReport1(){

    let defaultDate = {};
    defaultDate['Start_DateTime'] = [subDays(new Date(), 6), new Date()];
    defaultDate['Start_DateTime'][0].setHours(0, 0, 0, 0);
    defaultDate['Start_DateTime'][1].setHours(23, 59, 59, 999);
    defaultDate['noofdays'] = 7;
    let filterText = {};
    filterText['Select CallType'] = [{label : 'All', value : 'All'}];
    filterText['Select Employees'] = [{label : 'All', value : 'All'}];

    const [formname, setSetFormname] = useState(process.env.REACT_APP_CALLLOG_FORMNAME);
    const [showLoader, setShowLoader] = useState(false);
    const [filterTxt, setfilterTxt] = useState(filterText);
    const [dateFilter, setDateFilter] = useState(defaultDate);
    const [usersList, setUsersList] = useState('');
    const [chartOptionData, setChartOptionData] = useState({});  
    const [chartSeriesData, setChartSeriesData] = useState({});
    const [chartLabel, setChartLabels] = useState({});
    const [chartTypes, setChartTypes] = useState([]);
    const [callSummary, setCallCountSummary] = useState([]);

    useEffect(() => {
        getCallLogData();
        
    }, [])

    const getCallLogData = async () => {
        let params = {
            "ENTITY": "MOBILE_PROCESS",
            "OPERATION": "GET_USERS_FOR_CALL_LOG",
            "FORMNAME": formname,
            "isOtherApiReq" : true,
        };
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            let data = response.data;
            setUsersList(data);
            await loadAnalyticsData();
            
        }
    }

    const loadAnalyticsData = async () =>{
        setShowLoader(true);
        await prepareChartData();
        await getCallCountData();
        setShowLoader(false);
    }

    const getRequestJsonObj = (isDateFilter, operation) => {
        let filterOption = [dateFilter,filterTxt];
        let neededFilters = [
            {'dateFilter' : isDateFilter},
            {'users' : true},
            {'type' : true},
        ];
        let params = {
            "ENTITY": "MOBILE_PROCESS",
            "OPERATION": operation,
            "FORMNAME": formname,
            "isOtherApiReq" : true,
            "FILTEROPTION" : filterOption,
            "NEEDEDFILTERS" : neededFilters,
        };
        return params;
    }

    const prepareChartData = async () => {
        setChartOptionData({});
        setChartSeriesData({});
        setChartLabels({});
        setChartTypes([]);
        const promises = chartsList.map(async (chart, index) => {  
            let type = chart.type;
            let operation = chart.operation;
            let isDateFilter = type === "total_calls_by_user" || type === "total_calls_by_type" ? true : false;
            let params = getRequestJsonObj(isDateFilter, operation);
            let response = await requestApi.processServerRequest(params);
            if(response.issuccess){
                let data = response.data;
                let processedData = [];
                if(type === "total_calls_by_user"){
                    processedData[0] = data[0] !== undefined ? data[0] : [];
                    processedData[1] = [{name: 'Calls Count',data: data[1] !== undefined ? data[1] : []}];
                    processedData[2] = ['#008ffb', '#00e396', '#feb019', '#ff4560', '#775dd0', '#ff6347', '#5fbfc4', '#bfbfbf', '#80c25d', '#d0a994'];
                } else if (type === "total_calls_by_type"){
                    processedData[0] = data[0];
                    processedData[1] = [{name: 'Calls Count',data: data[1]}];
                } else if (type === "total_calls_by_Time") {
                    processedData[0] = data[0] ? data[0] : [];
                    processedData[1] = data[1] ? data[1] : [];
                } else if (type === "call_duration_by_time"){
                    processedData = data;
                    processedData[2] = [];
                }
                setDataForChart(processedData, chart);
            }
        });
        await Promise.all(promises); 
    }

    const setDataForChart = (data, chart) => {
        let {type, isHorizontal, colordistributed, tooltip} = chart;
        let isTooltipNeeded = false;
        let tooltipFormate = {};
        let yaxis = {};
        if(tooltip === 'time'){
            isTooltipNeeded = true
            tooltipFormate = {
                enabled: isTooltipNeeded,
                y: {
                    formatter: function (value) {
                        const hours = Math.floor(value / 3600);
                        const minutes = Math.floor((value % 3600) / 60);
                        const seconds = value % 60;
                        return `${hours}h ${minutes}m ${seconds}s`;
                    },
                },
            };
            yaxis = {
                labels: {
                    formatter: function (value) {
                        const hours = Math.floor(value / 3600);
                        const remainingSeconds = value % 3600;
                        const minutes = Math.floor(remainingSeconds / 60);

                        return `${hours}h ${minutes}m`;
                    },
                },
            }
        }

        let options = {
                chart: {
                    type: 'bar',
                    toolbar: {
                        show: false,
                    },
                    zoom: {
                        enabled: true,
                    }
                },
                dataLabels: {
                    enabled: false
                },
                plotOptions: {
                    bar: {
                        horizontal: isHorizontal,
                        distributed: colordistributed,
                        startingShape: "flat",
                        endingShape: "rounded",
                        dataLabels: {
                          position: 'bottom',
                          enabled: false,
                        },
                    }
                },
                xaxis: {
                    categories: data[0],
                    
                },
                yaxis: yaxis,
                tooltip: tooltipFormate,
                colors: data[2],
            };
        let series = data[1];
       
        setChartOptionData((prev) => ({ ...prev, [type]: options }));
        setChartSeriesData((prev) => ({ ...prev, [type]: series }));
        setChartLabels((prev) => ({ ...prev, [type]: chart.label }));
        setChartTypes((prev) => [...prev, type]);
        
    }

    const getCallCountData = async () => {
        setCallCountSummary([]);
        let params = getRequestJsonObj(true, "GET_CALL_COUNT_DATA");
    
        let responce = await requestApi.processServerRequest(params);
        if(responce.issuccess){
            let data = responce.data;
            setCallCountSummary(data);
        }
    }
    const handleDateChange = (name,selectedDates, noofdays) => {
        if(name === 'Start_DateTime'){
            dateFilter[name] = selectedDates;
            dateFilter['noofdays'] = noofdays;
            setDateFilter(dateFilter);
        }
    }

    const handleSelectChange = async (name,selectedOptions) => {
        filterTxt[name] = selectedOptions;
        setfilterTxt(filterTxt);
    }

    const handleBtnClick = async () => {
        let selecteduser = [...filterTxt['Select Employees'], ...usersList.filter(UserList => !filterTxt['Select Employees'].some(selectedOption => selectedOption.value === UserList.value))];
        setUsersList(selecteduser);
        await loadAnalyticsData();
    }

    let selectOptions = [
        {
            'name' : 'Select Employees',
            'label' : 'Select Employees',
            'options' : usersList,
            'multiple' : true,
            'id' : 0,
        },
        {
            'name' : 'Select CallType',
            'label' : 'Select CallType',
            'options' : callType,
            'multiple' : true,
            'defaultvalue' : 0,
            'id' : 1,
        }
    ];


    let dateOptions = [
        {
            name : `Start_DateTime`,
            placeholder : `Select Date Range`,
            defaultValue : dateFilter['Start_DateTime']
        }
    ];

    let buttons = [
        {
            name : 'search',
            lable : 'Search',
            icon : faMagnifyingGlass
        }
    ]

    return(
        <div>
            <Common
                pageTitle={"Calls Analytics"} 
                showLoader={showLoader} 
                mainContent={
                    <Fragment>
                        <FormHeader
                            selectOptions={selectOptions}
                            dateOptions={dateOptions}
                            handleDateChange={handleDateChange}
                            handleSelectChange={handleSelectChange}
                            handleBtnClick={handleBtnClick}
                            buttonOptions={buttons}
                            prefix={"calls_analytics"}
                        />
                        <div className="listview-container pb10 kv-main-wrapper h100per w-100">
                            <Summary
                                key={Math.random()}
                                formname={formname}
                                dateFilter={dateFilter}
                                filterTxt={filterTxt}
                                type={"calls_analytics"}
                                summaryData={callSummary}
                            /> 
                            <CSSTransition component="div" classNames="TabsAnimation" appear={true}
                                timeout={0} enter={false} exit={false}>
                                <Container fluid>
                                    <Row>
                                        {   
                                            chartTypes.map((type, index) => {
                                                if(typeof chartOptionData[type] !== undefined && typeof chartSeriesData[type] !== undefined){
                                                    let label = chartLabel[type];
                                                    return(
                                                        <>
                                                            <Col lg="6" className="call-log-charts ">
                                                                <Card className={"main-card mb-3"}>
                                                                    <CardBody>
                                                                        <CardTitle>{label}</CardTitle>
                                                                        <div className="bar">
                                                                            <ReactApexChart 
                                                                                options={chartOptionData[type]} 
                                                                                series={chartSeriesData[type]} 
                                                                                type="bar" 
                                                                                width={"100%"}
                                                                                height={450}
                                                                            />
                                                                        </div>
                                                                    </CardBody>
                                                                </Card>
                                                            </Col>
                                                        </>
                                                    )
                                                }
                                            })
                                        }                              
                                    </Row>
                                </Container>
                            </CSSTransition>
                        </div> 
                    </Fragment>
                }
            />
        </div>
    )

}
